import { Box, Button, Checkbox, OutlinedInput, Paper, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import employeeService from '../../services/EmployeeService';
import MandatoryQualificationSetup from './MandatoryQualificationSetup';
import NewItemDefaultAccounts from './NewItemDefaultAccounts';

const Setup = () => {
  const [costPlusChecked, setCostPlusChecked] = useState(false);
  const [markUpValue, setMarkUpValue] = useState('');

  const handleInputChange = (e) => {
    setMarkUpValue(e.target.value);
  };

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const employeeData = await employeeService.getEmployeeDetails();
        setCostPlusChecked(employeeData.data.data.BillableStatus);
        setMarkUpValue(employeeData.data.data.MarkUpPercentage ? employeeData.data.data.MarkUpPercentage : '');
      } catch (error) {
        toast.error('Could not fetch customer setup');
      }
    };
    fetchEmployeeDetails();
  }, []);

  const handleCostPlusSave = () => {
    function isMarkupPercentageValid(costPlusChecked, markUpValue) {
      if (costPlusChecked && markUpValue) return true;
      if (!costPlusChecked && !markUpValue) return true;
      return false;
    }

    if (!isMarkupPercentageValid(costPlusChecked, markUpValue)) {
      return toast.error('Markup percentage is required if cost plus is checked');
    }

    const markupData = {
      MarkUpPercentage: markUpValue,
      BillableStatus: costPlusChecked
    };

    employeeService
      .updateEmployeeMarkupPercentage(markupData)
      .then(() => {
        toast.success('Successfully updated customer setup');
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message || 'Could not update customer setup');
      });
  };

  return (
    <div>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          duration: 3000,
          success: {
            style: {
              background: '#36c95e',
              color: '#fff'
            }
          },
          error: {
            style: {
              background: '#f5251d',
              color: '#fff'
            }
          }
        }}
      />

      <div style={{ marginBottom: '3rem' }}>
        <Paper style={{ padding: '1rem' }}>
          <h3>Billable/Variation</h3>
          <div>
            <Checkbox
              name="superannuationChecked"
              checked={costPlusChecked}
              onChange={(e) => setCostPlusChecked(e.target.checked)}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />

            <span style={{ fontWeight: '500', fontFamily: 'Roboto, Helvetica, Arial, sans-serif' }}>
              Default Markup Percentage
            </span>
          </div>
          {costPlusChecked && (
            <div style={{ paddingLeft: '6%' }}>
              <Typography component="div" m={1} style={{ marginBottom: '0.6rem' }}>
                <Box fontWeight="fontWeightMedium"> Mark up(%)</Box>
              </Typography>
              <OutlinedInput
                name="costPlus"
                margin="dense"
                value={markUpValue}
                onChange={handleInputChange}
                type="number"
                fullWidth={true}
              />
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <Button onClick={handleCostPlusSave} color="primary" variant="contained">
              Save
            </Button>
          </div>
        </Paper>
      </div>

      <NewItemDefaultAccounts />
      <MandatoryQualificationSetup />
    </div>
  );
};

export default Setup;
